import {Component, HostBinding, Input} from '@angular/core';
import {Control} from '@catmodules/widgets/slide-in-modal/types';

@Component({
  selector: 'cat-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
})
export class ModalContentComponent {
  @Input() title: string;
  @Input() controls: Control[] = [];
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/widgets/slide-in-modal/components/modal-content/modal-content.component.ts